import React from 'react';
import PropTypes from 'prop-types';
import { Head } from 'vite-react-ssg';

const SITE_URL = 'https://lperron.com';
const DEFAULT_OG_IMAGE = '/og-default.png';

const PageMeta = ({ title, description, canonicalPath, image }) => {
  const fullTitle = title ? `${title} - Lucas Perron` : 'Lucas Perron - Creative Developer';
  const canonicalUrl = canonicalPath ? `${SITE_URL}${canonicalPath}` : SITE_URL;
  const ogImage = `${SITE_URL}${image || DEFAULT_OG_IMAGE}`;

  return (
    <Head>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Lucas Perron" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />
    </Head>
  );
};

PageMeta.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  canonicalPath: PropTypes.string,
  image: PropTypes.string,
};

export default PageMeta;
